'use client';
import { Button } from '@pickleballinc/react-ui';
import { useRouter, useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';

import { upDownOptions } from '@/modules/league/new-components/constants';
import { useLoader } from '@/modules/league/PickleballLoaderContext';
interface UpDownLeagueButtonsProps {
  currentSequenceNumber?: number;
}
const UpDownLeagueButtons = ({ currentSequenceNumber }: UpDownLeagueButtonsProps) => {
  const { setLoading } = useLoader();
  const searchParams = useSearchParams();
  const router = useRouter();

  const newSearchParams = new URLSearchParams(searchParams?.toString());
  const sequenceNumber = newSearchParams.get('sequenceNumber');
  // State to track the current sequence number
  const [activeSequenceNumber, setActiveSequenceNumber] = useState(
    sequenceNumber || currentSequenceNumber?.toString() || '1'
  );

  useEffect(() => {
    // Set default URL params with the updated round value
    newSearchParams.set('sequenceNumber', activeSequenceNumber);
    router.replace(`?${newSearchParams.toString()}`, { scroll: false });
  }, [activeSequenceNumber]);

  // Define button classes
  const baseButtonClasses =
    'rounded-md border 5rt3 bg-white !px-3 !py-2 !text-xs font-semibold lg:!text-sm tracking-wider !text-leagues-500 hover:bg-gray-100 border-gray-300 shadow-xs';
  const activeButtonClasses =
    '!border-leagues-700 !bg-leagues-700 !text-white hover:!bg-leagues-500';
  const inactiveButtonClasses = '';
  return (
    <div className='mx-auto flex h-auto w-full flex-row justify-end gap-2 px-3 py-1 md:flex-row md:px-3 md:py-0 md:pt-2'>
      {upDownOptions.map((round) => (
        <Button
          key={round.value}
          variant='link-gray'
          className={`${baseButtonClasses} ${round.value === activeSequenceNumber ? activeButtonClasses : inactiveButtonClasses}`}
          onClick={() => {
            setActiveSequenceNumber(round.value);
            setLoading(true);
          }}
        >
          {round.label}
        </Button>
      ))}
    </div>
  );
};
export default UpDownLeagueButtons;
